import { IRATrustTypes, YesNoEmpty } from '@interfaces/models';

import { TriageAccountType } from './triage-account.model';
import { TriageRelationshipType } from './triage-relationship.model';

export interface TriageForm {
  accountType: TriageAccountType;
  relationshipType?: TriageRelationshipType;
  isOnlyBeneficiary?: YesNoEmpty;
  isOnlyExecutor?: YesNoEmpty;
  isOnlyTrustee?: YesNoEmpty;
  wasMarried?: YesNoEmpty;
  isDecedentSpouse?: YesNoEmpty;
  isNotOnlyInheritingAccount?: boolean;
  isOnlyChild?: boolean;
  jointAccounts?: boolean[];
  typeOfTrust?: IRATrustTypes;
  isInheritedAccount?: YesNoEmpty;
  originalDecedentName?: string;
}
